// extracted by mini-css-extract-plugin
export default {"wrapper":"invoice-canceled-modal_wrapper__B5MFN","button":"invoice-canceled-modal_button__ZQo7s","opacity-transition":"invoice-canceled-modal_opacity-transition__m5s9x"};